export var EventHandler = {
  on: function on(target, evt, handlerFn) {
    target.addEventListener(evt, handlerFn);
  },
  off: function off(target, evt, handlerFn) {
    target.removeEventListener(evt, handlerFn);
  },
  trigger: function trigger(target, evt, args) {
    var event = new CustomEvent(evt, {
      bubbles: true,
      cancelable: true,
      detail: args
    });
    target.dispatchEvent(event);
  }
};